import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Sec6 } from '../sections/sec6/sec6'
import style from './syllabus.module.css'

const Syllabus = () => {
  const nav = useNavigate()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })

  }, [])
  const silabus = [
    {
      title: "קורסי בסיס",
      list: [
        "סדנת קוח ולינקדאין",
        "סדנת soft skills להכנה לקראת כניסה לארגון",
        "מבוא למחשבים",
        "בסיסי נתונים ו SQL"
      ]
    },
    {
      title: "UI/UX",
      list: [
        "HTML & CSS",
        "HTML5",
        "CSS3",
        "BOOTSTRAP 5.2",
        "SASS",
      ]
    },
    {
      title: "JAVA SCRIPT",
      list: [
        "JS OOP",
        "JS OOP ECMA 6",
        "JS JQUERY",
        "NODEJS"
      ]
    },
    {
      title: "Backend",
      list: [
        "NodeJs EXPRESS",
        "MONGO DB",
        "SQL",
        "NodeJs SOCKET",
        "NodeJs Information Security",
        "Create API (CRUD)"
      ]
    },
    {
      title: "Frontend",
      list: [
        "REACT JS",
        "React JS Hooks",
        "React JS Hooks REDUX"
      ]
    },
   
  ]
  return (
    <div className={style.bg} >
    <div className={style.box}>
           <div style={{ position: 'fixed', zIndex: 99, bottom: '5%', left: 0 }}  >
        <Button onClick={()=> window.scrollTo(0, document.body.scrollHeight-1300) } className={style.btnMoreDetail} sx={{ color: 'white', padding: '5px 10px', borderRadius: '0 25px 25px 0', fontFamily: 'Heebo', fontWeight: '100', fontSize: '13px' }} variant="contained" color="success">
          לבדיקת התאמה ופרטים
        </Button>
      </div>
      <div className='d-flex align-items-center flex-column py-4 '>
        <div className={style.underlineGradient + " mb-3"}></div>
        <h1 className={style.bigTitle + ` text-center`}>Fullstack Engineer Syllabus </h1>


      </div>
      <div className=" py-4">
        {silabus.map((item, i) => (
            
          <div  dir='rtl' className='mt-5' key={i}>
            <h4 className={style.title}>{item?.title}</h4>
            <ul style={{ listStyleType: 'none' }} className={style.ul1}>
              {item?.list.map((item, j) => (
                <p  key={j} className={style.li}> {item} </p>
              ))}
              
            </ul>
            
          </div>
        ))}
        <p style={{cursor:'pointer'}} className='text-decoration-underline py-3' onClick={() => nav(-1)}>Back Home Page</p>
      </div>

    </div>
    <Sec6/>
    </div>
  )
}

export default Syllabus